document.addEventListener("DOMContentLoaded", function () {
    //Read query string and url
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('Email');
    var subscribeLink = document.getElementById("mce-EMAIL");
    if (subscribeLink) {
        subscribeLink.value = myParam;
    }
});